'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var qs = require('qs');
var getToken = require('dibs-get-token');

require('isomorphic-fetch');

/**
 * Since fetch doesn't return a rejected promise if the http status code is an error,
 * this approach is recommended here https://github.com/github/fetch
 * @param   {Response} response
 * @returns {Response}
 * @throws  {Error}
 */
function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        var error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
}

function responseToJson(response) {
    return Promise.resolve(response).then(function (r) {
        if (r.json) {
            return r.json();
        }
        return r;
    });
}

/**
 * Convenience method to add common headers
 * @param   {Object} data
 * @returns {Object}
 */
function addHeaders(data) {
    return Object.assign({}, data, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    });
}

/**
 * Calls fetch (or isomorphic-fetch) and makes sure to throw an error if the status code is an error
 * @param   {Any} args
 * @returns {Promise}
 */
function fetchWrapper() {
    return fetch.apply(undefined, arguments).then(checkStatus).then(responseToJson);
}

/**
 * Adds a user token as a query parameter to url
 *
 * @param {String} url
 * @param {Object} [params]
 * @returns {String}
 */
function addTokenToUrl(url) {
    var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    return addParamsToUrl(url, Object.assign({}, getToken(), params));
}

/**
 * Adds a params to the url
 *
 * @param {String} url
 * @param {Object} params
 * @returns {String}
 */
function addParamsToUrl(url, params) {
    return url + '?' + qs.stringify(params);
}

/**
 * Some helper functions for simultaneously resolving/rejecting a Promise and calling a success/failure callback
 * @param {Function} resolve
 * @param {Function} reject
 * @param {Function} onSuccess
 * @param {Function} onFailure
 */
function conditionalPromiseHelpers(resolve, reject) {
    var onSuccess = arguments.length <= 2 || arguments[2] === undefined ? function () {} : arguments[2];
    var onFailure = arguments.length <= 3 || arguments[3] === undefined ? function () {} : arguments[3];

    var fail = function fail(args) {
        onFailure(args);
        return reject(args) || true;
    };
    var ok = function ok(args) {
        onSuccess(args);
        return resolve(args) || true;
    };
    var failIf = function failIf(cond, args) {
        return cond && fail(args);
    };

    // given an array of [condition, args], calls failIf with each args and returns false if any condition is false.
    var failIfAny = function failIfAny(conditionAndArgsList) {
        return conditionAndArgsList.reduce(function (prev, _ref) {
            var _ref2 = _slicedToArray(_ref, 2);

            var condition = _ref2[0];
            var args = _ref2[1];
            return prev || failIf(condition, args);
        }, false);
    };

    return { ok: ok, fail: fail, failIf: failIf, failIfAny: failIfAny };
}

module.exports = {
    addHeaders: addHeaders,
    fetchWrapper: fetchWrapper,
    addTokenToUrl: addTokenToUrl,
    addParamsToUrl: addParamsToUrl,
    conditionalPromiseHelpers: conditionalPromiseHelpers
};


//////////////////
// WEBPACK FOOTER
// ./~/dibs-service-fetch-wrappers/dist/util.js
// module id = 388
// module chunks = 4 6 8 9 16 17 22 26 29 58